export const SEARCH_MIN_TERM_LENGTH = 3

export const SEARCH_MIN_NUMERIC_TERM_LENGTH = 1

const NUMERIC_TERM_PATTERN = /^\d+$/

export function normalizeSearchTerm(search: string): string {
  return search.trim().replace(/\s+/g, ' ')
}

export function getSearchMinTermLength(search: string): number {
  return NUMERIC_TERM_PATTERN.test(normalizeSearchTerm(search))
    ? SEARCH_MIN_NUMERIC_TERM_LENGTH
    : SEARCH_MIN_TERM_LENGTH
}

export function isSearchTermValid(search: string): boolean {
  return normalizeSearchTerm(search).length >= getSearchMinTermLength(search)
}
